export default __webpack_public_path__ + "static/media/check.3ba65c6f.svg";